import { render, staticRenderFns } from "./OrderPicDialog.vue?vue&type=template&id=636d3e64&scoped=true&"
import script from "./OrderPicDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderPicDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPicDialog.vue?vue&type=style&index=0&id=636d3e64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d3e64",
  null
  
)

export default component.exports